import menu from './tr/menu'
import home from './tr/home'
import chat from './tr/chat'
import other from './tr/other'
import about from './tr/about'
import swap from './tr/swap'

const lang = {
	'app.switch.language.tips': '{{msg}} başarıyla değiştirildi',
	'app.language': 'Dil',
	'app.loading': 'Yükleniyor...',
	'connect.sign': 'İmzala...',
	'connect.btn': 'Bağlan',
	'connect.logout': 'Çıkış Yap',
	'connect.sign.error': 'İmza doğrulaması başarısız oldu',

	'layout.menu.stake': 'Para Yatırma',
	'layout.menu.withdraw': 'Çıkart',
	'layout.menu.team': 'Ekoloji',
	'düzen.menu.paylaş': 'Paylaş',

	'app.fee.title1': 'Birikmiş işlem ücreti',
	'app.fee.title2': 'Toplam hizmet adresi sayısı',
	'app.stake.tabs.title1': 'Tether USD',
	'app.stake.tabs.title2': 'Güncel gelir',
	'app.stake.tabs.title3': 'Topluluk',

	...menu,
	...home,
	...chat,
	...other,
	...about,
	...swap,
}

export default lang
